/** @format */

import React, { useState } from "react";
import { Button, Modal, Tag } from "antd";

interface IAccountsOverviewBillingModalProps {
	billingId: string;
	billingStyle?: string;
	lastRefill?: { amount: number; balanceAfter: number; requestingUser: string };
	currentBalance?: number;
}

const AccountsOverviewBillingModal: React.FC<
	IAccountsOverviewBillingModalProps
> = ({ billingId, billingStyle, lastRefill, currentBalance }) => {
	const [isBillingModalVisible, setIsBillingModalVisible] =
		useState<boolean>(false);

	const showBillingModal = () => {
		setIsBillingModalVisible(true);
	};

	// const handleBillingModalOk = () => {
	//   setIsBillingModalVisible(false);
	// };

	const handleBillingModalCancel = () => {
		setIsBillingModalVisible(false);
	};

	const renderCurrentBalance = () => {
		if (currentBalance) {
			if (currentBalance > 0)
				return (
					<span id="current-balance-positive">
						${currentBalance.toFixed(2)}
					</span>
				);
			else if (currentBalance < 0)
				return (
					<span id="current-balance-negative">
						${currentBalance.toFixed(2)}
					</span>
				);
		} else if (!currentBalance) {
			return null;
		}
	};

	const renderBillingTag = (currentBalance: number) => {
		if (currentBalance >= 0)
			return (
				<Tag
					style={{ cursor: "pointer" }}
					color="green"
					onClick={showBillingModal}>
					${currentBalance.toFixed(2)}
				</Tag>
			);
		else if (currentBalance < 0)
			return (
				<Tag
					style={{ cursor: "pointer" }}
					color="red"
					onClick={showBillingModal}>
					${currentBalance.toFixed(2)}
				</Tag>
			);
	};

	return (
		<div className="billing-modal-div">
			{currentBalance || currentBalance === 0
				? renderBillingTag(currentBalance)
				: null}
			<Modal
				title={
					<div>
						<span id="billing-id-modal-title">Billing Id:</span> {billingId}
					</div>
				}
				open={isBillingModalVisible}
				onCancel={handleBillingModalCancel}
				footer={[
					<Button key="close" onClick={handleBillingModalCancel} type="primary">
						Close
					</Button>,
				]}>
				<div className="billing-content-div current">
					<div id="current-balance-title">Current Balance</div>
					<div>{renderCurrentBalance()}</div>
				</div>
				<div className="billing-content-div">
					<div id="last-refill-title">Last Refill</div>
					<ul className="billing-modal-list">
						{billingStyle ? (
							<li>
								<span>Billing style:</span> {billingStyle}
							</li>
						) : null}
						{lastRefill ? (
							<div>
								<li>
									<span>Amount:</span> ${lastRefill.amount.toFixed(2)}
								</li>
								<li>
									<span>Balance after:</span> $
									{lastRefill.balanceAfter.toFixed(2)}
								</li>
								<li>
									<span>Requesting user:</span> {lastRefill.requestingUser}
								</li>
							</div>
						) : null}
					</ul>
				</div>
			</Modal>
		</div>
	);
};

export default AccountsOverviewBillingModal;
